import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router';
import { createPortal } from 'react-dom';

import { APP_ROUTES } from '@navigation/types';
import { useRecordedShow } from '@providers/RecordedShowProvider';

import Player from './components/Player';

const RecordedShowMiniPlayer = () => {
  const { currentRecordedShowId, closeCurrentRecordedShow } = useRecordedShow();
  const navigate = useNavigate();

  const goToShowScreen = useCallback(() => {
    navigate(`${APP_ROUTES.SHOW_RECORDED}/${currentRecordedShowId}`);
  }, [navigate, currentRecordedShowId]);

  const onClose = useCallback(() => {
    closeCurrentRecordedShow();
  }, [closeCurrentRecordedShow]);

  if (
    !currentRecordedShowId ||
    location.pathname.includes(APP_ROUTES.SHOW_RECORDED)
  ) {
    return null;
  }

  return createPortal(
    <Player
      showId={currentRecordedShowId}
      onClick={goToShowScreen}
      onClose={onClose}
    />,
    document.body,
  );
};

export default memo(RecordedShowMiniPlayer);
